// extracted by mini-css-extract-plugin
module.exports = {"card":"ui-card_card__TO5Em","hover":"ui-card_hover__lWn02"};